import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl } from 'react-intl';
import s from './FindYourCar.css';
//Components
import BookYourCarSkeleton from '../../Skeleton/BookYourCarSkeleton';
import BookYourCar from '../BookYourCar/BookYourCar';

class FindYourCar extends React.Component {

    static propTypes = {
        wholeData: PropTypes.object,
    };

    render() {
        const { wholeData } = this.props;
        let infoCollection = {};
        
        if (wholeData) {
            wholeData?.getFindYouCar.map((item, key) => {
                infoCollection[item.name] = item.value
            });
        }

        return (
            <div className={s.container}>
                {!wholeData || !wholeData.getFindYouCar ? 
                    <BookYourCarSkeleton /> : 
                    <BookYourCar infoCollection={infoCollection} />
                }
            </div>
        )
    }
}

export default injectIntl(withStyles(s)(FindYourCar));
